var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTabMoreFold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  fillRule: "evenodd",
  d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m0 1c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  fillRule: "evenodd",
  d: "M6.739 10.167a.57.57 0 0 1 .808 0L12 14.62l4.453-4.453a.571.571 0 0 1 .808.809l-4.857 4.857a.57.57 0 0 1-.808 0l-4.857-4.857a.57.57 0 0 1 0-.809",
  clipRule: "evenodd"
})));
export default SvgTabMoreFold;